import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'customDateFormat',
    standalone: false
})
export class CustomDateFormatPipe implements PipeTransform {
    transform(value: Date | string | null): string {
        if (!value) return '';

        const date = new Date(value);
        const day = date.getDate().toString().padStart(2, '0');
        const month = date.toLocaleString('en-US', { month: 'short' }).toUpperCase();
        const year = date.getFullYear();

        return `${day}-${month}-${year}`;
    }
}
@Pipe({
    name: 'customDateTimeFormat',
    standalone: false
})
export class CustomDateTimeFormatPipe implements PipeTransform {
    transform(value: Date | string | null): string {
        if (!value) return '';

        const date = new Date(value);
        const day = date.getDate().toString().padStart(2, '0');
        const month = date.toLocaleString('en-US', { month: 'short' }).toUpperCase();
        const year = date.getFullYear();

        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');

        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
    }
}
